/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Link_Editor_Save_BtnInputs */

const en_link_editor_save_btn = /** @type {(inputs: Link_Editor_Save_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Save Live Changes`)
};

const es_link_editor_save_btn = /** @type {(inputs: Link_Editor_Save_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Guardar Cambios en Vivo`)
};

const fr_link_editor_save_btn = /** @type {(inputs: Link_Editor_Save_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Enregistrer les modifications en ligne`)
};

const de_link_editor_save_btn = /** @type {(inputs: Link_Editor_Save_BtnInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Live-Änderungen speichern`)
};

/** @type {(inputs: Link_Editor_Save_BtnInputs) => LocalizedString} */
const ja_link_editor_save_btn = en_link_editor_save_btn;

/** @type {(inputs: Link_Editor_Save_BtnInputs) => LocalizedString} */
const zh_link_editor_save_btn = en_link_editor_save_btn;

/** @type {(inputs: Link_Editor_Save_BtnInputs) => LocalizedString} */
const ar_link_editor_save_btn = en_link_editor_save_btn;

/** @type {(inputs: Link_Editor_Save_BtnInputs) => LocalizedString} */
const id_link_editor_save_btn = en_link_editor_save_btn;

/** @type {(inputs: Link_Editor_Save_BtnInputs) => LocalizedString} */
const it_link_editor_save_btn = en_link_editor_save_btn;

/** @type {(inputs: Link_Editor_Save_BtnInputs) => LocalizedString} */
const ru_link_editor_save_btn = en_link_editor_save_btn;

/** @type {(inputs: Link_Editor_Save_BtnInputs) => LocalizedString} */
const pt_link_editor_save_btn = en_link_editor_save_btn;

/** @type {(inputs: Link_Editor_Save_BtnInputs) => LocalizedString} */
const ko_link_editor_save_btn = en_link_editor_save_btn;

/**
* | output |
* | --- |
* | "Save Live Changes" |
*
* @param {Link_Editor_Save_BtnInputs} inputs
* @param {{ locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }} options
* @returns {LocalizedString}
*/
export const link_editor_save_btn = /** @type {((inputs?: Link_Editor_Save_BtnInputs, options?: { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Link_Editor_Save_BtnInputs, { locale?: "en" | "es" | "fr" | "de" | "ja" | "zh" | "ar" | "id" | "it" | "ru" | "pt" | "ko" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_link_editor_save_btn(inputs)
	if (locale === "es") return es_link_editor_save_btn(inputs)
	if (locale === "fr") return fr_link_editor_save_btn(inputs)
	if (locale === "de") return de_link_editor_save_btn(inputs)
	if (locale === "ja") return ja_link_editor_save_btn(inputs)
	if (locale === "zh") return zh_link_editor_save_btn(inputs)
	if (locale === "ar") return ar_link_editor_save_btn(inputs)
	if (locale === "id") return id_link_editor_save_btn(inputs)
	if (locale === "it") return it_link_editor_save_btn(inputs)
	if (locale === "ru") return ru_link_editor_save_btn(inputs)
	if (locale === "pt") return pt_link_editor_save_btn(inputs)
	return ko_link_editor_save_btn(inputs)
});